/* ==========================================================================
   THE STATION · DECK 01 · THE FRONT DECK (V99)
   Two front decks share the hero. 01 THE VESSEL is the bottle carousel.
   02 THE BALLOONS is the crew, as balloons the size of the screen: watcher
   heads in the five inks rising on strings through the whole deck, texting
   you from their phones — a typing bubble first, then the line — and popping.
   THE TURN: the deck changes on a clock (theme setting, seconds) and the dial
   shows how long each deck has left. A tap on the dial jumps early and the
   clock restarts. ?hero=vessel|balloons pins a deck for that page view; the
   theme setting can pin one for everybody.
   Nothing here sells; the CLAIM button under both decks is the same button,
   now wearing whichever crew colour the nav's claim button is wearing.
   ========================================================================== */
(function(){
  'use strict';
  var d = document, de = d.documentElement;
  var hero = d.getElementById('arrivals');
  if(!hero) return;
  var sky = d.getElementById('heroSky');
  var dial = d.getElementById('heroDial');
  var REDUCED = false;
  try { REDUCED = matchMedia('(prefers-reduced-motion: reduce)').matches; } catch(e){}

  /* ---------- the crew ---------- read from station.js when aboard; the same table stands in if not */
  var CREW = [
    ['green', '#00CE7E', '#1E7A42', 'OKO'],
    ['pink',  '#EA41AA', '#8E2B5C', 'VESP'],
    ['red',   '#FC4539', '#7F1212', 'KOR'],
    ['yellow','#F8E44B', '#8A6905', 'SOL'],
    ['blue',  '#389EE1', '#143A8F', 'RIME']
  ];
  try {
    if (typeof CREW_ACTIVE !== 'undefined' && CREW_ACTIVE && CREW_ACTIVE.length >= 5) {
      CREW = CREW_ACTIVE.map(function(c){ return [c[0], c[3], c[4], (typeof CREW_CHAR !== 'undefined' && CREW_CHAR[c[0]]) ? CREW_CHAR[c[0]].name : c[1].replace(' ALIEN','')]; });
    }
  } catch(e){}
  function crewOf(k){ for (var i = 0; i < CREW.length; i++) if (CREW[i][0] === k) return CREW[i]; return null; }

  /* ---------- what they text ----------
     pairs go out in order: the call on one balloon, the answer on the next.
     The crew have been watching runners, cyclists and swimmers for 8 billion
     years, and every generation of them: the lines cover the field from
     "back in my day" to "no cap" to "skibidi" (nobody over twelve knows either). */
  var PAIRS = [
    /* the aliens */
    ['I am your father.', 'Dad?'],
    ['Take me to your leader.', 'Kidding. Take me to your bike.'],
    ['Are you my mother?', 'Wrong species. Close, though.'],
    ['Which one of you is the alien?', 'Trick question.'],
    ['Is this thing on?', 'It has been on for 8 billion years.'],
    ['We come in peace.', 'And in five colors.'],
    ['Mom says come home.', 'Tell her I\u2019m hydrating.'],
    ['Stop staring at me.', 'The staring is included.'],
    ['You look thirsty.', '22 ounces. Two eyes. Your move.'],
    ['Do you come here often?', 'Every night. The pumps never close.'],
    ['u up?', 'Since 8 billion years ago.'],
    ['Where are you?', 'Last stop before deep space. Come get me.'],
    /* looking for dad */
    ['Have you seen my dad?', 'Two eyes. Doesn’t blink. Answers to nobody.'],
    ['Are you my dad?', 'Depends. Do you run?'],
    ['Dad went out for water.', 'That was 8 billion years ago.'],
    ['Dad?', 'Not me. Try the blue one.'],
    ['Found my dad.', 'It was a bottle. Close enough.'],
    /* the field */
    ['What\u2019s your pace?', 'Yes.'],
    ['How far today?', 'Far enough for the snack.'],
    ['Did you stretch?', 'I thought about it. Counts.'],
    ['Carb loading?', 'Since Tuesday.'],
    ['Zone 2?', 'Zone \u201ctalk the whole time.\u201d'],
    ['Coffee ride?', 'The ride is optional.'],
    ['Flip turn?', 'Optional. Like dignity.'],
    ['Swim? In that?', 'It\u2019s a lake. Goggles on.'],
    ['Open water?', 'The fish aren\u2019t judging. Much.'],
    ['Rest day?', 'Aggressively.'],
    /* the generations, in conversation */
    ['Back in my day we ran without watches.', 'Uphill. Both ways. We know.'],
    ['Whatever. I\u2019ll ride.', 'That\u2019s Gen X for \u201cI love it.\u201d'],
    ['I can\u2019t even.', 'You can. 22 ounces says so.'],
    ['No cap, that hill ate me.', 'For Dad: the hill was steep.'],
    ['It\u2019s giving marathon.', 'It\u2019s giving 5K with confidence.'],
    ['Skibidi.', 'Nobody over twelve knows either.'],
    ['Hydrate or diedrate.', 'A Millennial wrote that. It stays.'],
    ['I\u2019m fine.', 'Gen X for \u201cI\u2019m dying.\u201d']
  ];
  var SINGLES = [
    /* the aliens */
    'Water not included.',
    'One of a hundred. Which one are you?',
    'Blink. We dare you.',
    'The gods never left. Neither did we.',
    'Not from here. Neither are you.',
    'Glow accordingly.',
    'Wake up. You\u2019re one of us.',
    'Nobody picks their crew. It picks you.',
    'Last stop before deep space. Fill up.',
    'Phone\u2019s for you. It\u2019s the void.',
    'Left the ship running.',
    'Do these eyes look big to you?',
    'You were never asleep. Just tired.',
    'Two eyes. No blink. Zero regrets.',
    '8 billion asleep. Not you.',
    'I know what you burn.',
    'Dad? Is that you?',
    'Still looking for my dad. Still hydrating.',
    'Dad, if you’re reading this: fill up.',
    'Any dads out there? Asking for 8 billion of us.',
    'Pop.',
    'Sent from my mothership.',
    'Read 0.618 seconds ago.',
    /* running */
    'Ran 5K. Told 5K people.',
    'Long run Sunday. Long nap Sunday.',
    'You\u2019re not slow. You\u2019re building suspense.',
    'Pace yourself. That\u2019s the whole sport.',
    'Fartlek is a real word. We checked.',
    'Negative split. Positive attitude. Pick one.',
    'Runner\u2019s high is real. Runner\u2019s snacks are realer.',
    'Adulting is a marathon. I signed up for the 5K.',
    'Ate that hill. No crumbs.',
    'That tempo run was lowkey unhinged.',
    'Six-seven miles. Don\u2019t ask.',
    'Whatever. I\u2019ll run. Don\u2019t make it a thing.',
    /* cycling */
    'N+1 bikes. Always N+1.',
    'Shaved legs. Faster. Science.',
    'Dropped my friends. Sorry. Not sorry.',
    'Bonked at mile 40. Ate a gel. Reborn.',
    'Headwind both ways. Physics owes me.',
    'Tan lines are a personality.',
    'Bidon. That\u2019s the word. You won\u2019t use it.',
    'One gear was fine. It was not fine.',
    'Meh. Draft me.',
    'Bought a bike to save money. Then bike money.',
    'This climb is lowkey personal.',
    'Descending: main character energy.',
    'Sigma cadence.',
    /* swimming */
    'Swam 2K. Smell like 2K chlorine.',
    'Goggle tan. Earned.',
    'Breaststroke is the resting stroke. Coach disagrees.',
    'Sighted the wrong buoy. Twice.',
    'Ask a swimmer the time. You\u2019ll get a 100.',
    'Butterfly: named after a bug for a reason.',
    'We swam in the lake. The lake swam back.',
    'Pool\u2019s closed. Whatever. Ocean.',
    'Wetsuit: the leggings of the sea.',
    'Lane 4 is giving chaos.',
    'That kick set was not it.',
    'Skibidi splash.',
    /* all three */
    'Swim. Bike. Run. Snack. Nap.',
    'Transition is the fourth sport.',
    'Brick workout. Feels like bricks.',
    'I can\u2019t even. But I did. 10K.',
    'Hydration check. No cap.',
    'It\u2019s giving 22 ounces.',
    'Your blood is 92% water. Fill up before deep space.',
    'You\u2019re 60% water. We hold the top-up.'
  ];
  try {
    var extra = (window.STATION_HERO_SAYINGS || '').split(/\r?\n/).map(function(s){ return s.trim(); }).filter(Boolean);
    if (extra.length) SINGLES = SINGLES.concat(extra);
  } catch(e){}

  /* ---------- THE TRANSMITTER ----------
     The crew do not read from a list. They build each line from a grammar —
     a theme, a template, slots filled from the crew's own vocabulary — seeded
     fresh every visit, checked against everything said in this session AND
     against the last 160 lines this browser has seen (localStorage), so a
     visitor who comes back reads new ones. The hand-written classics above
     stay in the mix as one voice among the themes. Themes: looking for mom or
     dad · the water in you · the field (run, ride, swim) · the generations
     · the station. Every hydration number is true. All of it stays kid-safe. */
  function rng(seed){ var s = seed >>> 0 || 1; return function(){ s ^= s << 13; s >>>= 0; s ^= s >>> 17; s ^= s << 5; s >>>= 0; return (s % 100000) / 100000; }; }
  var VISITS = 0; try { VISITS = (parseInt(localStorage.getItem('stationHero.visits') || '0', 10) || 0) + 1; localStorage.setItem('stationHero.visits', String(VISITS)); } catch(e){}
  var R = rng((Date.now() ^ (VISITS * 2654435761)) & 0xffffffff);
  function pick(a){ return a[Math.floor(R() * a.length)]; }
  var SLOT = {
    parent: ['dad', 'mom', 'father', 'mother', 'papa', 'ma'],
    parents: ['dads', 'moms', 'parents'],
    trait: ['Two eyes. Doesn\u2019t blink', 'Green, sometimes pink', 'Smells like chlorine', 'Wears the tan lines', 'Runs before sunrise', 'Still out on the bike', 'Owns five bottles', 'Never blinks first', 'Answers to \u201chey\u201d'],
    test: ['Depends. Do you run?', 'Say something about hydration.', 'Blink. We\u2019ll wait.', 'What\u2019s your pace? Yes is the answer.', 'Depends. Do you swim?', 'Blink twice for yes.', 'What do you burn?'],
    thing: ['water', 'electrolytes', 'a bike', 'a long run', 'a swim', 'a coffee ride'],
    ago: ['That was 8 billion years ago.', 'Still out.', 'Sent a text. No reply.', 'Left the ship running.', 'The pumps are still open.', 'Took the long way.', 'Went for the coffee ride first.'],
    found: ['a bottle', 'a bike', 'a lane rope', 'a 5K medal', 'a very tall stranger', 'a bidon', 'the mothership', 'a headwind'],
    slang: ['Skibidi', 'Sigma', 'Ohio'],
    hour: ['6', '7', '8'],
    biketime: ['6:45', '7:45', '9'],
    color: ['green', 'pink', 'red', 'yellow', 'blue'],
    plea: ['fill up', 'come home', 'text back', 'pick a color', 'blink twice'],
    topup: ['We hold the top-up', 'Act like it', 'Fill up before deep space', 'The other 40% is stubborn'],
    act: ['Fill up before deep space', 'Keep it that way', 'That\u2019s the good stuff'],
    brainquip: ['The staring uses all of it', 'Thinking is a wet sport', 'Hydrate to think'],
    lungquip: ['Breathe. Then drink', 'Both need topping up'],
    dry: ['You\u2019re drying out', 'Fix one', 'Fill up'],
    tryq: ['Try harder', 'They don\u2019t run, though', 'Be the jellyfish'],
    pun: ['diedrate', 'be tired', 'cry-drate'],
    who: ['A Millennial', 'A Boomer', 'Gen Z', 'A Gen X-er'],
    inc: ['The staring', 'The company', 'The judgment'],
    dist: ['5K', '10K', 'a half', '26.2', 'a mile'],
    mile: ['12', '40', '60', '80', '2'],
    fuel: ['gel', 'banana', 'waffle', 'gas-station burrito'],
    k: ['2', '3', '4', '5'],
    debt: ['Physics', 'The weather app', 'The map', 'Someone'],
    sorry: ['Sorry. Not sorry.', 'They\u2019ll text.', 'That\u2019s what friends are for.'],
    adv: ['Aggressively', 'Loudly', 'In full kit', 'Twice', 'On the couch', 'With intent'],
    opt: ['Optional. Like dignity', 'Optional. Like breathing', 'Only on Tuesdays'],
    x: ['ride', 'coffee', 'bike'],
    times: ['Twice', 'Three times', 'Again', 'Every time'],
    pace: ['Easy', 'Tempo', 'Race', 'Zone 2'],
    pquip: ['Nobody agrees what that means', 'Talk the whole time', 'Suffer quietly'],
    yes: ['Yes', 'Depends who\u2019s asking', 'Fast enough', 'Slow enough'],
    tan: ['personality', 'uniform', 'calendar', 'love language'],
    stretch: ['I thought about it. Counts', 'In spirit', 'Tomorrow, definitely'],
    when: ['Tuesday', 'birth', 'the last race', 'breakfast'],
    nth: ['fourth', 'hardest', 'forgotten'],
    bricks: ['bricks', 'a wall', 'Tuesday'],
    status: ['Earned', 'Permanent', 'A choice'],
    old: ['ran without watches', 'rode one gear', 'swam in the lake', 'hydrated from a hose', 'had one bottle. Total'],
    sport: ['ride', 'run', 'swim', 'race'],
    obs: ['hill', 'headwind', 'kick set', '400'],
    adj: ['steep', 'long', 'hard', 'brutal'],
    big: ['marathon', 'ultra', '140.6', 'a grand tour'],
    small: ['5K', 'sprint tri', 'spin class', 'group ride'],
    age: ['twelve', 'eleven', 'thirteen'],
    session: ['tempo run', 'climb', 'kick set', 'long ride'],
    genz: ['unhinged', 'personal', 'not it', 'a lot'],
    check: ['Hydration', 'Cadence', 'Pace', 'Goggle'],
    lane: ['1', '4', '6', '8'],
    vibe: ['chaos', 'main character', 'ultra', 'warm-up'],
    race: ['5K', 'fun run', 'kids\u2019 dash', 'cheering'],
    sigma: ['cadence', 'hydration', 'cooldown'],
    unit: ['miles', 'laps', 'gels'],
    lact: ['Fill up', 'Come get me', 'Bring a friend', 'Glow accordingly'],
    you: ['you', 'your crew', 'the one reading this'],
    phi: ['0.618', '1.618', '2.618'],
    ship: ['mothership', 'vessel', 'bike', 'lane'],
    itpicks: ['It picks you', 'It just shows up', 'Mostly the green one'],
    which: ['Which one are you?', 'Which one is yours?'],
    since: ['8 billion years ago', 'the Big Bang', 'the pumps opened'],
    place: ['Last stop before deep space', 'The mothership', 'Lane 4', 'Mile 40'],
    /* V127 · the year's worth */
    cuke: ['Show-off', 'Respect', 'Still not a vessel'],
    wm: ['Coincidence? Yes', 'Nature\u2019s vessel', 'Fill up either way'],
    cc: ['a love language', 'not optional', 'the whole sport'],
    lanes: ['circle swim', 'don\u2019t be the wall', 'tap, don\u2019t grab', 'no drafting the kids'],
    rm: ['bib on, brain off', 'the porta-potty line is the warm-up', 'trust the taper', 'nothing new on race day'],
    tm: ['real', 'contagious', 'a lifestyle', 'a group chat'],
    aero: ['everything', 'a haircut', 'in the mind', 'free speed, paid in dignity'],
    gel: ['regret', 'birthday cake, allegedly', 'the finish line', 'a decision'],
    fr: ['tiny torture', 'a hug that hurts', 'the good pain', 'a personality test'],
    bc: ['one gear, all heart', 'stop when done', 'no watch, no problem', 'ask the sun'],
    mc: ['a podcast', 'an oat milk latte', 'a spreadsheet', 'a photo of the bike'],
    gz: ['a fit check', 'three videos', 'lowkey a nap', 'vibes'],
    gx: ['fine', 'whatever', 'still riding', 'not making it a thing'],
    ga: ['skibidi splits', 'sigma cadence', 'six-seven everything', 'Ohio hills'],
    okoq: ['Still watching', 'Never blinked', 'Hasn\u2019t looked away', 'Saw the finish first too'],
    vespq: ['Golden hour is hers', 'Ride until she says', 'Headlight after that', 'She dims the sky herself'],
    korq: ['Do not shake', 'Handle with intent', 'Built for the last mile', 'Red for a reason'],
    solq: ['Or ever', 'Try it', 'Sunscreen helps', 'Noon is his warm-up'],
    rimeq: ['Winter\u2019s favorite', 'Bring a jacket', 'Diesel energy', 'Starts cold, finishes first'],
    phiq: ['Proportion is the point', 'Everything here is cut to it', 'Write it down', 'The gods agreed'],
    p6: ['the good part', 'still a bottle', 'a sip short', 'the golden sip'],
    fib: ['1, 1, 2, 3, 5', '8, 13, 21', '34, 55, 89', '144, 233, 377'],
    deck: ['02 is the vessel bay', '03 is salvage', '07 is the deep freezer', '12 is the arcade', '16 is the schoolhouse', '17 is the picture house', '09 is the approach'],
    crewname: ['OKO', 'VESP', 'KOR', 'SOL', 'RIME'],
    alt: ['5,280', '8,000', '10,000'],
    altq: ['Drink like it', 'Breathe like it', 'The air is thin. The water isn\u2019t'],
    smell: ['chlorine', 'chamois cream', 'a gas-station burrito', 'ambition'],
    one: ['one', 'two', 'three', 'whatever day it is'],
    where: ['at the pumps', 'on the trainer', 'in lane 4', 'at mile 40', 'on the group ride', 'at the register', 'behind the freezer'],
    verdict: ['Close enough', 'Same eyes', 'Counts', 'We\u2019ll take it'],
    did: ['Ran', 'Biked', 'Swam', 'Walked', 'Raced'],
    dist2: ['5K', '10K', 'a half', '26.2', 'a mile', '40 miles', '2K', 'a lap'],
    audience: ['5K people', 'the group chat', 'a stranger', 'the dog', 'everyone at the pumps', 'nobody, for once'],
    rebirth: ['Reborn', 'Forgiven', 'Back', 'Alive', 'Slightly better'],
    where2: ['both ways', 'all day', 'on the flat', 'in the pool, somehow', 'uphill only'],
    gen: ['Boomer', 'Gen X', 'Millennial', 'Gen Z', 'Gen Alpha'],
    act: ['warm-up', 'cooldown', 'cadence', 'hydration', 'recovery', 'race plan'],
    how: ['one gear, all heart', 'stop when done', 'no watch, no problem', 'ask the sun', 'a podcast', 'an oat milk latte', 'a spreadsheet', 'a photo of the bike', 'a fit check', 'three videos', 'lowkey a nap', 'vibes', 'fine', 'whatever', 'still riding', 'not making it a thing', 'skibidi splits', 'sigma cadence', 'six-seven everything', 'Ohio hills'],
    deckq: ['Go look', 'The crew are there', 'Bring the vessel', 'Nobody blinks there', 'Doors are open'],
    crewact: ['is staring', 'saw you', 'is at the pumps', 'logged a burn', 'texted first', 'took the last gel'],
    crewq: ['Still watching', 'Never blinked', 'Bring water', 'Say hi', 'Don\u2019t ask'],
    lid: ['pulled the lid with your teeth', 'squeezed it at a light', 'dropped it at mile 40', 'named it']
  };
  var GRAMMAR = {
    family: [
      ['Have you seen my {parent}?', '{trait}. Answers to nobody.'],
      ['Are you my {parent}?', '{test}'],
      ['{Parent} went out for {thing}.', '{ago}'],
      ['Found my {parent}.', 'It was {found}. Close enough.'],
      ['{Parent}?', 'Not me. Try the {color} one.'],
      ['I am your {parent}.', '{Parent}?'],
      ['Still looking for my {parent}. Still hydrating.'],
      ['{Parent}, if you\u2019re reading this: {plea}.'],
      ['Any {parents} out there? Asking for 8 billion of us.'],
      ['Missing: one {parent}. Reward: the staring. Included.'],
      ['Text me, {parent}.', 'Read {phi} seconds ago. No reply.'],
      ['{Parent} says hi.', 'Which one?'],
      ['Drink some water, {parent}.'],
      ['Missing: one {parent}. Last seen {where}.'],
      ['Found my {parent} {where}. It was {found}. {verdict}.'],
      ['{Parent}, {plea}. Then meet me {where}.'],
      ['Missing: one {parent}. Last seen {where}. {trait}.']
    ],
    water: [
      ['You\u2019re about 60% water. {topup}.'],
      ['Your blood is 92% water. {act}.'],
      ['The brain is 73% water. {brainquip}.'],
      ['Lungs: 83% water. {lungquip}.'],
      ['Newborn: 75% water. You: 60%. {dry}.'],
      ['Jellyfish: 95% water. You: 60%. {tryq}.'],
      ['Hydrate or {pun}.', '{who} wrote that. It stays.'],
      ['Water not included. {inc} is.'],
      ['Cucumber: 96% water. {cuke}.'],
      ['Watermelon: 92% water. Same as your blood. {wm}.'],
      ['Altitude: {alt} feet. {altq}.'],
      ['You smell like {smell}. Fill up anyway.']
    ],
    field: [
      ['Ran {dist}. Told {dist} people.'],
      ['Bonked at mile {mile}. Ate a {fuel}. Reborn.'],
      ['Swam {k}K. Smell like {k}K chlorine.'],
      ['Headwind both ways. {debt} owes me.'],
      ['Dropped my friends.', '{sorry}'],
      ['Rest day?', '{adv}.'],
      ['Flip turn?', '{opt}.'],
      ['Coffee ride?', 'The {x} is optional.'],
      ['Sighted the wrong buoy. {times}.'],
      ['{pace} pace. {pquip}.'],
      ['What\u2019s your pace?', '{yes}.'],
      ['Tan lines are a {tan}.'],
      ['Did you stretch?', '{stretch}.'],
      ['Carb loading?', 'Since {when}.'],
      ['Transition is the {nth} sport.'],
      ['Brick workout. Feels like {bricks}.'],
      ['Goggle tan. {status}.'],
      ['Group ride at {hour}.', 'That\u2019s {biketime} in bike time.'],
      ['Chamois cream is {cc}.'],
      ['Lane etiquette: {lanes}.'],
      ['Race morning: {rm}.'],
      ['Taper madness is {tm}.'],
      ['Aero is {aero}.'],
      ['Gels taste like {gel}.'],
      ['Foam roller: {fr}.'],
      ['You {lid}. We saw.'],
      ['{did} {dist2}. Told {audience}.'],
      ['Bonked at mile {mile}. Ate a {fuel}. {rebirth}.'],
      ['Headwind {where2}. {debt} owes me.'],
      ['Race morning: {rm}. Then {rm}.'],
      ['{did} {dist2} {where2}. {rebirth}.'],
      ['Bonked at mile {mile} {where2}. Ate a {fuel}. {rebirth}.']
    ],
    generations: [
      ['Back in my day we {old}.', 'Uphill. Both ways. We know.'],
      ['Whatever. I\u2019ll {sport}.', 'That\u2019s Gen X for \u201cI love it.\u201d'],
      ['I can\u2019t even.', 'You can. 22 ounces says so.'],
      ['No cap, that {obs} ate me.', 'For Dad: the {obs} was {adj}.'],
      ['It\u2019s giving {big}.', 'It\u2019s giving {small} with confidence.'],
      ['{slang}.', 'Nobody over {age} knows either.'],
      ['That {session} was lowkey {genz}.'],
      ['{check} check. No cap.'],
      ['Lane {lane} is giving {vibe}.'],
      ['Adulting is a marathon. I signed up for the {race}.'],
      ['Sigma {sigma}.'],
      ['Six-seven {unit}. Don\u2019t ask.'],
      ['Boomer cadence: {bc}.'],
      ['Millennial cooldown: {mc}.'],
      ['Gen Z warm-up: {gz}.'],
      ['Gen X: {gx}.'],
      ['Gen Alpha: {ga}.'],
      ['{gen} {act}: {how}.'],
      ['{gen} {act} {where}: {how}.']
    ],
    crew: [
      ['OKO saw us first. {okoq}.'],
      ['VESP keeps the last hour of light. {vespq}.'],
      ['KOR is the pressure vessel. {korq}.'],
      ['SOL does not blink at noon. {solq}.'],
      ['RIME: cold starts, long hauls. {rimeq}.'],
      ['{crewname} says hi.', 'Which one?'],
      ['Which one is {crewname}?', 'The one staring. So, all of them.'],
      ['{crewname} {crewact}. {crewq}.'],
      ['{crewname} {crewact} {where}. {crewq}.'],
      ['The purple one?', 'Across the street from the bike shop. Ordered. Inbound.'],
      ['Six of us soon.', 'The purple one is on his way. Don\u2019t tell the register.'],
      ['Purple is real.', 'We saw the purchase order.'],
      ['The black one?', 'Midnight. In the bike shop. Somewhere. Look up.'],
      ['The graphite one?', 'Same ship as the black one. That is why you never see either.'],
      ['Black and graphite.', 'One mothership. They blend. That is the whole point.'],
      ['The orange one?', 'Ask the cone at the ramp. Then ask again.'],
      ['The white one?', 'Standing next to the white shells. Count them. Count again.'],
      ['The teal one?', 'In the pool. Or it is the pool. Nobody checked.'],
      ['The AI one?', 'Copper. The wire it thinks through. Nobody had made it. Now somebody has.'],
      ['What is the black one called?', 'Midnight. When somebody sees him.'],
      ['The gold one?', 'Behind the till. Priced in something we don\u2019t take.'],
      ['How many are there?', 'Thirteen. Five you can buy. The rest you have to see.'],
      ['Sodium and water?', 'Not at the pool. The lifeguard has a rule.'],
      ['Chromium plus iron.', 'Stainless. That is OKO and KOR, together.'],
      ['Fool\u2019s gold?', 'Sulfur and iron. SOL and KOR. The gold one is not amused.'],
      ['Copper plus weather?', 'Teal. Give the AI one time.'],
      ['Carbon plus pressure?', 'A diamond. Midnight and graphite, one crystal. Unseen.'],
      ['Gold plus anything?', 'Gold. That is the whole point of gold.']
    ],
    kids: [
      ['Son.', 'Dad.'],
      ['Daughter.', 'Mom.'],
      ['Dad, are we there yet?', 'We are in orbit.'],
      ['Mom, the bottle is staring at me.', 'That is the bottle.'],
      ['My son sleeps till noon.', 'Noon is SOL\u2019s warm-up.'],
      ['My daughter runs faster than me.', 'Everyone\u2019s daughter runs faster than them.'],
      ['Son, did you drink your water?', 'I named it.'],
      ['Daughter, did you drink your water?', 'It drank me. Kidding. Yes.'],
      ['Dad joke incoming.', 'We are already in space. Cannot leave.'],
      ['Mom said no more bottles.', 'Mom is not on this deck.'],
      ['My son says he is too old for water bottles.', 'He is twelve. He is not too old for anything.'],
      ['My daughter took my vessel to the track.', 'Then it is her vessel now. That is the rule.'],
      ['Dad, why does it have eyes?', 'So it can find you at the aid station.'],
      ['Mom, why is it 618?', 'Ask your father. He has a spreadsheet.'],
      ['Son, we do not name the bottles.', 'His name is Dennis.'],
      ['Daughter, your bottle is in the freezer.', 'Deep freezer. Around back. She knows.'],
      ['Dad, one more lap.', 'One more lap is how we got here.'],
      ['Mom, he is looking at me.', 'He is looking at everyone. That is his job.'],
      ['My son says the green one is his.', 'My daughter says the green one is hers.', 'Two greens. One hundred. Sort it out.'],
      ['Grandpa says he ran without watches.', 'Uphill. Both ways. We know.'],
      ['Son, take a water bottle.', 'Dad, it is a vessel.'],
      ['Daughter, take a vessel.', 'Mom, it is a water bottle.'],
      ['Family meeting.', 'Who has the pink one.'],
      ['My kid asked if aliens drink water.', 'Sixty percent of them, yes.'],
      ['Can we get a dog?', 'We have a bottle that stares. Same thing.'],
      ['Dad, the bottle winked.', 'Bottles cannot wink.', 'It winked.'],
      ['Mom, the bottle winked.', 'That is the design.', 'It winked, Mom.'],
      ['Son, I found your vessel at the pool.', 'The teal one? That is the pool.'],
      ['Daughter, whose bike is on the hoist?', 'Not mine. Mine is in the garage.', 'Level P1?', 'Level P1.']
    ],
    numbers: [
      ['\u03c6 = 1.618. {phiq}.'],
      ['0.618 of a bottle is {p6}.'],
      ['Fibonacci: {fib}. Then hydrate.'],
      ['Deck {deck}.'],
      ['Deck {deck}. {deckq}.']
    ],
    siderep: [
      ['Who counts your reps?', 'SideRep. Coming soon. siderep.co'],
      ['Got a club?', 'SideRep has one for every sport. Fifty of them.'],
      ['The body doesn\u2019t lie.', 'SideRep counts. siderep.co'],
      ['Where do you log the burn?', 'The Burn Trail. Here, and in SideRep.'],
      ['Coach?', 'SideRep. Seven modes. One of them is honest.'],
      ['Scanned your feet lately?', 'SideRep does. Foot to shoe.'],
      ['SideRep: the app the crew use between vessels. Coming soon.'],
      ['siderep.co. Write it on your hand.'],
      ['Rep one is the hard one. SideRep counts the rest.'],
      ['Fifty sports. One app. SideRep.'],
      ['Sent from the mothership\u2019s other app. SideRep.']
    ],
    station: [
      ['Last stop before deep space. {lact}.'],
      ['8 billion asleep. Not {you}.'],
      ['Read {phi} seconds ago.'],
      ['Sent from my {ship}.'],
      ['Nobody picks their crew. {itpicks}.'],
      ['One of a hundred. {which}'],
      ['u up?', 'Since {since}.'],
      ['Where are you?', '{place}. Come get me.']
    ]
  };
  var THEMES = ['family', 'water', 'field', 'field', 'generations', 'station', 'kids', 'siderep', 'crew', 'kids', 'numbers'];
  /* V189 · RÓTA on the sky: the day turns the deck — each weekday leans on a different theme, so the house line and the rest never sit in the same weight two days running */
  (function(){ var lean = ['field', 'kids', 'water', 'crew', 'family', 'station', 'generations'][new Date().getDay()]; THEMES.push(lean, lean); })();   /* one draw in ten is the house ad, and it says so */
  /* ---------- THE CALENDAR ---------- the year turns and the crew notice: dates, seasons, weekdays, the hour */
  function nthWeekday(y, m, dow, n){ var d = new Date(y, m, 1); var add = (dow - d.getDay() + 7) % 7; return 1 + add + (n - 1) * 7; }
  function lastWeekday(y, m, dow){ var d = new Date(y, m + 1, 0); var back = (d.getDay() - dow + 7) % 7; return d.getDate() - back; }
  function calendar(){
    var now = new Date(), y = now.getFullYear(), m = now.getMonth(), dd = now.getDate(), dow = now.getDay(), h = now.getHours(), out = [];
    var on = function(mm, d1, d2){ return m === mm && dd >= d1 && dd <= (d2 || d1); };
    if (on(0, 1, 3)) out.push(['New year. Same crew. New water.'], ['Resolution: hydrate. Day {one}.', ]);
    if (m === 0) out.push(['January miles are made of ice and denial.']);
    if (on(1, 14)) out.push(['Roses are red. Vessels are five colors. Happy Valentine\u2019s.'], ['Be mine.', 'I have two eyes and no blink. Yes.']);
    if (on(1, 29)) out.push(['Leap day. Extra day. Extra bottle.']);
    if (m === 2 && dd === nthWeekday(y, 2, 0, 2)) out.push(['Spring forward. Lose an hour. Keep the pace.']);
    if (on(2, 14)) out.push(['Pi day. We prefer phi. 1.618.']);
    if (on(2, 17)) out.push(['Green day for OKO. Everyone else, pace yourself.']);
    if (on(3, 1)) out.push(['April Fools. The bottles are real. We are not.']);
    if (m === 3 && dd === nthWeekday(y, 3, 1, 3)) out.push(['Patriots\u2019 Day. Heartbreak Hill is a state of mind.']);
    if (on(3, 22)) out.push(['Earth Day. Our second favorite planet.']);
    if (m === 4) out.push(['Bike month. Wave at cars.']);
    if (m === 4 && dd === nthWeekday(y, 4, 0, 2)) out.push(['Mother\u2019s Day. Are you my mother? Still asking.']);
    if (m === 4 && dd === lastWeekday(y, 4, 1)) out.push(['Memorial Day. Run for the ones who can\u2019t.']);
    if (m === 5 && dd === nthWeekday(y, 5, 0, 3)) out.push(['Father\u2019s Day.', 'I am your father. Dad?']);
    if (on(5, 20, 22)) out.push(['Longest day. Longest ride. Shortest excuse.']);
    if (on(6, 4)) out.push(['Fourth of July. The yellow one is the fireworks.']);
    if (m === 6) out.push(['July. Someone\u2019s riding around France. Ride around the block.']);
    if (m === 7) out.push(['August. Every bottle is a hot bottle. Fill early.']);
    if (m === 8 && dd === nthWeekday(y, 8, 1, 1)) out.push(['Labor Day.', 'Rest day. Aggressively.']);
    if (m === 8) out.push(['September. The light gets long. The runs get longer.']);
    if (m === 9) out.push(['Boulderthon season. Boulder knows.'], ['October. Arm warmers on. Arm warmers off. Arm warmers on.']);
    if (on(9, 31)) out.push(['Halloween. The alien costume is not a costume.']);
    if (m === 10 && dd === nthWeekday(y, 10, 0, 1)) out.push(['Fall back. Extra hour. Extra sleep. Not extra miles.']);
    if (m === 10 && dd === nthWeekday(y, 10, 4, 4)) out.push(['Turkey trot. Then pie. Then hydrate. In that order.']);
    if (on(11, 24, 26)) out.push(['Merry everything. The crew are off. The pumps aren\u2019t.']);
    if (on(11, 31)) out.push(['New Year\u2019s Eve. Last stop before next year.']);
    if (m === 11 || m <= 1) out.push(['Trainer season. The wall is not judging you. Much.']);
    if (m >= 2 && m <= 4) out.push(['Spring. The bike remembers you.']);
    if (m >= 5 && m <= 7) out.push(['Summer. Sunscreen. Then water. Then more water.']);
    if (m >= 8 && m <= 10) out.push(['Fall. The good light. The good miles.']);
    var wk = [['Sunday. Long run Sunday. Long nap Sunday.'], ['Monday.', 'Rest day. Aggressively.'], ['Tuesday. Track night. Bring the vessel.'], ['Wednesday. Hump day. Hill day.'], ['Thursday. Tempo. Talk less.'], ['Friday. Group ride. Coffee optional.'], ['Saturday. The long one.']];
    out.push(wk[dow]);
    if (h >= 4 && h < 7) out.push(['Dawn patrol. Respect.']);
    else if (h >= 7 && h < 10) out.push(['Morning. Coffee counts as water.', 'It doesn\u2019t.']);
    else if (h >= 12 && h < 14) out.push(['Lunch run. Chafe risk: high.']);
    else if (h >= 21 || h < 4) out.push(['You\u2019re up late. So are we. 8 billion years.']);
    return out;
  }
  var CAL = calendar();
  if (CAL.length) { GRAMMAR.calendar = CAL; THEMES.push('calendar', 'calendar'); }
  var CLASSICS = SINGLES.map(function(s){ return [s]; }).concat(PAIRS);
  function cap(s){ return s.charAt(0).toUpperCase() + s.slice(1); }
  function fill(tpl){
    var bind = {};
    return tpl.map(function(line){
      return line.replace(/\{(\w+)\}/g, function(_, key){
        var k = key.charAt(0).toLowerCase() + key.slice(1), up = key.charAt(0) !== k.charAt(0);
        if (!(k in bind)) bind[k] = SLOT[k] ? pick(SLOT[k]) : key;
        return up ? cap(bind[k]) : bind[k];
      });
    });
  }
  var said = {}, history = [];
  try { history = JSON.parse(localStorage.getItem('stationSaid') || '[]'); if (!Array.isArray(history)) history = []; } catch(e){ history = []; }
  var hist = {}; history.forEach(function(h){ hist[h] = 1; });
  function remember(lines){
    var k = lines.join(' / '); said[k] = 1; history.push(k);
    if (history.length > 600) history = history.slice(-600);
    try { localStorage.setItem('stationSaid', JSON.stringify(history)); } catch(e){}
  }
  function fresh(lines){ var k = lines.join(' / '); return !said[k] && !hist[k]; }
  function compose(){
    for (var tries = 0; tries < 14; tries++) {
      var theme = (R() < 0.2) ? 'classic' : pick(THEMES);
      var lines = theme === 'classic' ? pick(CLASSICS).slice() : fill(pick(GRAMMAR[theme]));
      if (fresh(lines)) { remember(lines); return { lines: lines, theme: theme }; }
    }
    var th = pick(THEMES), any = fill(pick(GRAMMAR[th])); remember(any); return { lines: any, theme: th };   /* the sky has heard everything: say it anyway */
  }
  var pending = null;
  /* a line is { t: text, from: sender label or null }. House ads carry their own label — the fine print says house ads are marked as ours. */
  function nextLine(){
    if (pending) { var p = pending; pending = null; return p; }
    var c = compose(), from = c.theme === 'siderep' ? 'SIDEREP \u00b7 HOUSE AD' : null;
    if (c.lines.length > 1) pending = { t: c.lines[1], from: from };
    return { t: c.lines[0], from: from };
  }
  window.STATION_TRANSMIT = function(n){ var out = []; for (var i = 0; i < (n || 20); i++) { var l = nextLine(); out.push(l.from ? l.from + ' :: ' + l.t : l.t); } return out; };

  /* ---------- the figure ---------- the site's own watcher path as the head, knotted onto the vessel below it */
  var HEAD = 'M50 6 C77 6 92 26 92 48 C92 74 72 96 50 104 C28 96 8 74 8 48 C8 26 23 6 50 6 Z';
  function headSVG(hex, ink){
    return '<svg class="bl-head" viewBox="0 0 100 116" aria-hidden="true">'
      + '<path d="M50 102 L44 114 L56 114 Z" fill="' + hex + '"/>'
      + '<path d="' + HEAD + '" fill="' + ink + '" stroke="' + hex + '" stroke-width="3"/>'
      + '<g class="eye"><ellipse cx="33" cy="52" rx="14" ry="20" transform="rotate(-18 33 52)" fill="' + hex + '"/><circle class="pupil" cx="33" cy="52" r="5" fill="#04120A"/></g>'
      + '<g class="eye"><ellipse cx="67" cy="52" rx="14" ry="20" transform="rotate(18 67 52)" fill="' + hex + '"/><circle class="pupil" cx="67" cy="52" r="5" fill="#04120A"/></g>'
      + '<path d="M30 20 C36 14 44 12 50 12" fill="none" stroke="#FFFFFF" stroke-width="2.4" stroke-linecap="round" opacity=".55"/>'
      + '</svg>';
  }
  /* the body: the real vessel photo. station.js carries the five as OG_IMG; the theme also
     ships them as assets for the still deck, so either source serves */
  function bottleSrc(k){
    try { if (typeof OG_IMG !== 'undefined' && OG_IMG && OG_IMG[k]) return OG_IMG[k]; } catch(e){}
    var base = (typeof window.STATION_ASSETS === 'string' && window.STATION_ASSETS) ? window.STATION_ASSETS : '';
    return base ? (base + 'og-' + k + '-618.webp') : '';
  }
  function bottleHTML(c){
    var src = bottleSrc(c[0]);
    if (src) return '<img class="bl-bottle" src="' + src + '" alt="" draggable="false">';
    /* no photo aboard: a drawn vessel in the crew's ink */
    return '<svg class="bl-bottle bl-bottle-svg" viewBox="0 0 34 107" aria-hidden="true"><rect x="12" y="0" width="10" height="9" rx="2" fill="#111"/><path d="M7 9 h20 v6 h-2 v86 a4 4 0 0 1 -4 4 h-8 a4 4 0 0 1 -4 -4 v-86 h-2 z" fill="#F4F8F8"/><rect x="9" y="40" width="16" height="36" rx="3" fill="' + c[1] + '"/></svg>';
  }
  function esc(s){ return String(s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  /* the message: sender line, then a phone bubble that types before it speaks */
  function msgHTML(c, say){
    var from = say.from ? esc(say.from) : (esc(c[3]) + ' \u00b7 now');
    return '<div class="bl-msg' + (say.from ? ' bl-ad' : '') + '"><span class="bl-from">' + from + '</span>'
      + '<span class="bl-say"><i class="bl-typing" aria-hidden="true"><b></b><b></b><b></b></i><span class="bl-txt">' + esc(say.t) + '</span></span></div>';
  }

  /* ---------- the field ---------- the whole deck is the sky */
  function field(box, opts){
    var alive = 0, timer = 0, running = false, crewAt = Math.floor(R() * CREW.length);
    var opening = 0;   /* how many of the first figures get a head start */
    function spawn(headStart){
      if (!running) return;
      var h = box.clientHeight, w = box.clientWidth;
      if (h < 60 || w < 120) { timer = setTimeout(spawn, 900); return; }
      var small = w < 640;
      var cap = small ? opts.phoneMax : opts.max;
      if (alive >= cap) { timer = setTimeout(spawn, 800); return; }
      headStart = (typeof headStart === 'number') ? headStart : 0;   /* seconds already flown, so the sky is not empty at the start */
      var lo = small ? opts.phone[0] : opts.size[0], hi = small ? opts.phone[1] : opts.size[1];
      var size = Math.round(lo + R() * (hi - lo));
      var c0 = null;
      var lane = opts.lanes[Math.floor(R() * opts.lanes.length)];
      var x = lane[0] + R() * (lane[1] - lane[0]);
      /* the words hold the floor and the dial holds the top-right; a message only shows in the open sky between them */
      var hb = hero.getBoundingClientRect();
      var kick = hero.querySelector('.hero-in .kicker'), dl = d.getElementById('heroDial');
      var blockH = kick ? Math.max(0, hb.bottom - kick.getBoundingClientRect().top) : h * 0.4;
      var dialB = dl ? Math.max(0, dl.getBoundingClientRect().bottom - hb.top) : 0;
      var maskZone = h * 0.12 + 8;
      var topH = (small || x > 58) ? Math.max(dialB, maskZone) : maskZone;
      var bubbleH = small ? 76 : 88;
      var rise = Math.round(h + size * 2.97 + 60);        /* head 1.16 + vessel 1.95 - the overlap, in sizes */
      var total = rise + size * 1.5;                       /* the animation runs from 1.5 sizes under the floor to -rise */
      var typeTravel = Math.max(0, blockH - size * 1.13 + 26);   /* the bubble sits 0.34 sizes below the crown: clear once that passes the words */
      var popTravelMax = h - topH - bubbleH - size * 1.13; /* and it must be gone before it reaches the dial or the fade */
      var c = CREW[crewAt % CREW.length]; crewAt += 1 + Math.floor(R() * 2);
      var dur = (small ? opts.phoneDur[0] + R() * (opts.phoneDur[1] - opts.phoneDur[0]) : opts.dur[0] + R() * (opts.dur[1] - opts.dur[0]));
      var ms = dur * 1000;
      var typeAt = ms * (typeTravel / total) + R() * 500;
      var sayAt  = typeAt + 900 + R() * 700;
      var popMax = ms * (popTravelMax / total);
      var say = (R() < opts.talk && popMax - sayAt >= 2200) ? nextLine() : null;   /* no room to be read: the balloon rises quiet */
      var el = d.createElement('div');
      el.className = 'bl' + (x > 56 ? ' flip' : '');
      el.style.cssText = '--x:' + x.toFixed(1) + '%;--size:' + size + 'px;--dur:' + dur.toFixed(2) + 's;--sway:' + (3 + R() * 2.4).toFixed(2) + 's;'
        + '--hue:' + c[1] + ';--ink:' + c[2] + ';--rise:' + rise + 'px;--z:' + size + ';--tilt:' + ((R() * 6 - 3).toFixed(1)) + 'deg'
        + (headStart ? ';animation-delay:-' + headStart.toFixed(2) + 's' : '');
      el.setAttribute('data-crew', c[0]);
      el.innerHTML = '<div class="bl-body">' + (say ? msgHTML(c, say) : '') + headSVG(c[1], c[2]) + bottleHTML(c) + '</div>';
      box.appendChild(el); alive++;
      var popped = false, timers = [];
      function pop(){
        if (popped) return; popped = true;
        el.classList.add('pop');
        var body = el.firstChild, n = 9;
        for (var i = 0; i < n; i++) { var s = d.createElement('i'); s.className = 'bl-shard'; s.style.setProperty('--a', (i * (360 / n) + R() * 20).toFixed(0) + 'deg'); s.style.setProperty('--d', (Math.round(size * 0.5) + R() * size * 0.4).toFixed(0) + 'px'); body.appendChild(s); }
        timers.push(setTimeout(gone, 1150));   /* the vessel has to finish falling */
      }
      function gone(){ if (el.parentNode) el.parentNode.removeChild(el); alive--; timers.forEach(clearTimeout); }
      var popAt = 0;
      if (say) popAt = Math.min(popMax, sayAt + 3600 + R() * Math.max(0, popMax - sayAt - 3600));   /* read, then pop before the words up top */
      else if (R() < opts.popRate) popAt = ms * (0.45 + R() * 0.4);
      if (headStart) {   /* the clocks run from where the figure already is */
        var hs = headStart * 1000;
        typeAt = Math.max(250, typeAt - hs); sayAt = Math.max(typeAt + 700, sayAt - hs);
        if (popAt) popAt = Math.max(sayAt + 2000, popAt - hs);
        if (say && popMax - hs - sayAt < 1800) { var mm = el.querySelector('.bl-msg'); if (mm) mm.parentNode.removeChild(mm); say = null; }
      }
      if (say) { timers.push(setTimeout(function(){ if (!popped) el.classList.add('talk'); }, typeAt)); timers.push(setTimeout(function(){ if (!popped) el.classList.add('said'); }, sayAt)); }
      if (popAt) timers.push(setTimeout(pop, popAt));
      el.addEventListener('animationend', function(ev){ if (ev.target === el) gone(); });   /* drifted off the top */
      el._pop = pop;
      if (opening > 0) { opening--; timer = setTimeout(function(){ spawn(opening > 0 ? 2.2 + R() * 4.5 : 0); }, 180 + R() * 260); }   /* the opening wave lands fast */
      else timer = setTimeout(spawn, opts.gap[0] + R() * (opts.gap[1] - opts.gap[0]));
    }
    box.addEventListener('click', function(e){
      var fig = e.target.closest('.bl'); if (!fig) return;
      if (e.target.closest('.bl-bottle')) {   /* V160: tap the vessel and it is a coin toss — the balloon pops, or the vessel goes straight into the hold */
        var k = fig.getAttribute('data-crew'), gone = false;
        try { gone = (typeof soldOut === 'function') && soldOut('v-' + k); } catch(err){}
        if (gone || R() < 0.5) { if (fig._pop) fig._pop(); return; }
        var b = d.createElement('button'); b.type = 'button'; b.setAttribute('data-add', 'v-' + k); b.style.cssText = 'position:fixed;left:-9999px;top:-9999px;opacity:0;pointer-events:none';
        d.body.appendChild(b);
        try { b.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, clientX: e.clientX, clientY: e.clientY })); } catch(err){}
        setTimeout(function(){ if (b.parentNode) b.parentNode.removeChild(b); }, 50);
        fig.classList.add('claimed');
        return;
      }
      if (fig._pop) fig._pop();                                                                   /* the head is a balloon: tap it, it pops and the vessel drops */
    });
    return {
      start: function(){
        if (running) return; running = true; box.classList.remove('static'); box.innerHTML = ''; alive = 0; clearTimeout(timer);
        opening = (box.clientWidth < 640) ? 2 : 4;
        timer = setTimeout(function(){ spawn(3.5 + R() * 4); }, 60);   /* the first one is already a third of the way up */
      },
      stop: function(){ if (!running) return; running = false; clearTimeout(timer); box.innerHTML = ''; alive = 0; }
    };
  }
  /* the crew heads on the manifest do exactly this; same door, same bay */
  function goVessel(k){
    var vi = 0; for (var i = 0; i < CREW.length; i++) if (CREW[i][0] === k) vi = i;
    try { sessionStorage.setItem('vWant', String(vi)); } catch(e){}
    if (window.STATION_LOCK) { window.location.href = '/#/bottles'; return; }
    if (!/^#\/bottles/.test(location.hash)) location.hash = '#/bottles';
    setTimeout(function(){ if (window.STATION_GO_VESSEL) window.STATION_GO_VESSEL(vi); try { sessionStorage.removeItem('vWant'); } catch(e){} }, 140);
  }
  /* ---------- 03 THE FACES ---------- the printed eyes, alive */
  var faces = (function(){
    var stage = d.getElementById('heroFaces'); if (!stage) return null;
    var figs = Array.prototype.slice.call(stage.querySelectorAll('.hf-fig'));
    var running = false, blinkTimers = [], wander = 0, fine = false;
    try { fine = matchMedia('(pointer: fine)').matches; } catch(e){}
    function look(px, py){
      figs.forEach(function(fig){
        var svg = fig.querySelector('.hf-eyes'); if (!svg) return;
        var rx = parseFloat(svg.getAttribute('data-rx')) || 27, ry = parseFloat(svg.getAttribute('data-ry')) || 39;
        var r = svg.getBoundingClientRect(); if (!r.width) return;
        var vb = svg.viewBox.baseVal; var k = vb.width / r.width;   /* screen px → photo px */
        svg.querySelectorAll('.hf-pupil').forEach(function(p){
          var cx = r.left + parseFloat(p.getAttribute('cx')) / k, cy = r.top + parseFloat(p.getAttribute('cy')) / k;
          var dx = px - cx, dy = py - cy, dist = Math.hypot(dx, dy) || 1;
          var reach = Math.min(1, dist / 260);
          p.setAttribute('transform', 'translate(' + (dx / dist * reach * rx * 0.42).toFixed(1) + ' ' + (dy / dist * reach * ry * 0.42).toFixed(1) + ')');
        });
      });
    }
    function onMove(e){ if (running) look(e.clientX, e.clientY); }
    function blinkOne(fig){
      var svg = fig.querySelector('.hf-eyes'); if (!svg) return;
      svg.classList.add('blink'); setTimeout(function(){ svg.classList.remove('blink'); }, 150);
      if (R() < 0.22) setTimeout(function(){ svg.classList.add('blink'); setTimeout(function(){ svg.classList.remove('blink'); }, 140); }, 260);
    }
    function schedule(fig, i){ var tmr = setTimeout(function(){ if (!running) return; blinkOne(fig); schedule(fig, i); }, 2600 + R() * 4800); blinkTimers.push(tmr); }
    function drift(){ if (!running) return; var hb = hero.getBoundingClientRect(); look(hb.left + hb.width * (0.2 + R() * 0.6), hb.top + hb.height * (0.1 + R() * 0.6)); wander = setTimeout(drift, 1800 + R() * 2200); }
    stage.addEventListener('click', function(e){ var f = e.target.closest('.hf-fig'); if (f) goVessel(f.getAttribute('data-crew')); });
    stage.addEventListener('keydown', function(e){ if (e.key !== 'Enter' && e.key !== ' ') return; var f = e.target.closest('.hf-fig'); if (f) { e.preventDefault(); goVessel(f.getAttribute('data-crew')); } });
    return {
      set: function(on){
        if (on === running) return;
        running = on;
        blinkTimers.forEach(clearTimeout); blinkTimers = []; clearTimeout(wander);
        if (!on || REDUCED) return;
        figs.forEach(schedule);
        if (fine) addEventListener('pointermove', onMove, { passive: true }); else drift();
      }
    };
  })();
  var skyField = sky ? field(sky, { size: [88, 140], phone: [54, 80], lanes: [[3, 30], [30, 56], [56, 82], [82, 97]], dur: [20, 28], phoneDur: [16, 22], gap: [1600, 3000], max: 6, phoneMax: 4, talk: 0.85, popRate: 0.7 }) : null;

  /* ---------- the turn ---------- the clock that changes the deck, and what the dial shows */
  var SETTING = (window.STATION_HERO === 'vessel' || window.STATION_HERO === 'balloons' || window.STATION_HERO === 'faces') ? window.STATION_HERO : 'turn';
  var q = /[?&]hero=(vessel|balloons|faces)/.exec(location.search);
  var PINNED = q ? q[1] : (SETTING === 'turn' ? null : SETTING);
  var SECS = parseInt(window.STATION_HERO_SECONDS, 10); if (!(SECS >= 1)) SECS = 34; if (SECS > 155) SECS = 155;
  var ROTATE = !PINNED;
  var ORDER = ['vessel', 'balloons', 'faces'];
  function mode(){ var m = de.getAttribute('data-hero'); return (m === 'balloons' || m === 'faces') ? m : 'vessel'; }
  function other(m){ return ORDER[(ORDER.indexOf(m) + 1) % ORDER.length]; }
  var visible = true, tabOn = true;
  var left = SECS * 1000, lastTick = 0, ticking = 0;
  var DECK_NAME = { vessel: '01 THE VESSEL', balloons: '02 THE BALLOONS', faces: '03 THE FACES' };
  function fmt(msLeft){ var ms = Math.max(0, msLeft); var s = Math.floor(ms / 1000); return 'T\u2212' + Math.floor(s / 60) + ':' + ('0' + (s % 60)).slice(-2) + '.' + Math.floor((ms % 1000) / 100); }
  var chrono = d.getElementById('heroChrono');
  function paintDial(){
    if (!dial) return;
    var m = mode();
    dial.querySelectorAll('[data-hero-pick]').forEach(function(b){ b.setAttribute('aria-pressed', b.getAttribute('data-hero-pick') === m ? 'true' : 'false'); });
    dial.classList.toggle('pinned', !ROTATE);
    if (!chrono) return;
    if (!ROTATE) { chrono.hidden = true; return; }
    chrono.hidden = false;
    var track = chrono.querySelector('.hc-track'), tEl = chrono.querySelector('.hc-t'), nEl = chrono.querySelector('.hc-next');
    if (track) track.style.setProperty('--hc-p', Math.max(0, Math.min(1, left / (SECS * 1000))).toFixed(4));
    if (tEl) tEl.textContent = fmt(left);
    if (nEl) nEl.textContent = 'JUMP \u2192 ' + DECK_NAME[other(m)];
  }
  function setDeck(m, restart){
    if (m !== mode()) {
      hero.classList.add('turning');
      if (dial) { dial.classList.add('jump'); setTimeout(function(){ dial.classList.remove('jump'); }, 700); }
      setTimeout(function(){ de.setAttribute('data-hero', m); hero.classList.remove('turning'); sync(); }, 260);
    }
    if (restart) { left = SECS * 1000; }
    paintDial();
  }
  function tick(){
    var now = Date.now();
    if (ROTATE && visible && tabOn) {
      if (lastTick) left -= (now - lastTick);
      if (left <= 0) { setDeck(other(mode()), true); }
    }
    lastTick = now;
    paintDial();
  }
  var claimSync = null;   /* set once the CLAIM button is wired, below */
  function sync(){
    if (claimSync) claimSync();
    var on = mode() === 'balloons' && visible && tabOn && !REDUCED;
    if (skyField) { on ? skyField.start() : skyField.stop(); }
    if (sky) sky.setAttribute('aria-hidden', mode() === 'balloons' ? 'false' : 'true');
    if (faces) faces.set(mode() === 'faces' && visible && tabOn);
    paintDial();
  }
  if (REDUCED && sky) sky.classList.add('static');
  if (dial) dial.addEventListener('click', function(e){
    var b = e.target.closest('[data-hero-pick]'); if (!b) return;
    setDeck(b.getAttribute('data-hero-pick'), true);
  });
  try { if ('IntersectionObserver' in window) new IntersectionObserver(function(es){ es.forEach(function(en){ visible = en.isIntersecting; }); sync(); }, { threshold: 0 }).observe(hero); } catch(e){}
  d.addEventListener('visibilitychange', function(){ tabOn = !d.hidden; lastTick = 0; sync(); });
  addEventListener('hashchange', function(){ setTimeout(sync, 60); });
  var rz = 0; addEventListener('resize', function(){ clearTimeout(rz); rz = setTimeout(sync, 200); });
  sync();
  if (ROTATE) ticking = setInterval(tick, 100);   /* tenths on the readout */
  window.STATION_HERO_SET = function(pick){ setDeck((pick === 'balloons' || pick === 'faces') ? pick : 'vessel', true); };

  /* ---------- the CLAIM button wears the crew colours ----------
     station-claim.js already turns the nav's claim button through the five
     inks every 1.7s; the hero button mirrors it so the two never disagree.
     Black stays the ink on every hue (THE OG GREEN LAW). When the quick-claim
     panel opens, the colour it was wearing is the tile in the spotlight. */
  var qcBtn = d.getElementById('quickClaimBtn');
  if (qcBtn) {
    var navClaim = d.querySelector('.claim-btn');
    var own = 0, ci = Math.floor(R() * CREW.length);
    function liveCrew(){ return CREW.filter(function(c){ try { return (typeof soldOut === 'function') ? !soldOut('v-' + c[0]) : true; } catch(e){ return true; } }); }
    function wear(c){
      if (!c) return;
      qcBtn.style.background = c[1]; qcBtn.style.borderColor = c[1]; qcBtn.style.color = '#05070C';
      qcBtn.style.setProperty('--fehu-hue', c[1]);
      qcBtn.setAttribute('data-wearing', c[0]);
    }
    function mirror(){ var k = navClaim && navClaim.dataset.claimColor; var c = k && crewOf(k); if (c) { wear(c); return true; } return false; }
    /* 01 THE VESSEL: the button is the colour of the bottle on show, the moment it shows.
       02 THE BALLOONS: no single bottle is on show, so it turns with the nav's claim button. */
    function shown(){ var k = window.STATION_SHOWN; return k ? crewOf(k) : null; }
    function paintClaim(){
      if (mode() === 'vessel') { var c = shown(); if (c) { wear(c); return true; } }
      return mirror();
    }
    claimSync = paintClaim;
    addEventListener('station:vessel', function(){ if (mode() === 'vessel') paintClaim(); });
    if (navClaim && 'MutationObserver' in window) {
      new MutationObserver(function(){ if (mode() !== 'vessel' || !shown()) mirror(); }).observe(navClaim, { attributes: true, attributeFilter: ['data-claim-color', 'style'] });
    }
    /* if nothing upstream is turning the colours, turn them here */
    setTimeout(function(){ if (!paintClaim()) { var l = liveCrew(); if (l.length) { wear(l[ci % l.length]); own = setInterval(function(){ ci++; var lc = liveCrew(); if (lc.length && !paintClaim()) wear(lc[ci % lc.length]); }, 1700); } } }, 400);
    qcBtn.addEventListener('click', function(){
      var k = qcBtn.getAttribute('data-wearing'); if (!k) return;
      setTimeout(function(){
        var qc = d.getElementById('quickClaim'); if (!qc || qc.hidden) return;
        qc.querySelectorAll('.qc-hue.wearing').forEach(function(t){ t.classList.remove('wearing'); });
        var tile = qc.querySelector('[data-qc="' + k + '"]');
        if (tile) { tile.classList.add('wearing'); try { tile.focus({ preventScroll: true }); } catch(e){} }
      }, 80);
    });
  }
})();


/* ==========================================================================
   V107 · THE METEORS — one streak every so often, upper half of the sky,
   behind the content. Off on the dayside, off for reduced motion, off when
   the tab is hidden. Seeded like everything else so the rhythm feels made.
   ========================================================================== */
(function(){
  'use strict';
  var d = document, de = d.documentElement;
  var REDUCED = false; try { REDUCED = matchMedia('(prefers-reduced-motion: reduce)').matches; } catch(e){}
  if (REDUCED) return;
  var s = (Date.now() & 0xffff) || 7;
  function R(){ s ^= s << 13; s >>>= 0; s ^= s >>> 17; s ^= s << 5; s >>>= 0; return (s % 100000) / 100000; }
  function streak(){
    if (d.hidden || de.classList.contains('day')) return;
    var m = d.createElement('i');
    m.className = 'meteor';
    m.style.cssText = '--mx:' + (4 + R() * 62).toFixed(1) + '%;--my:' + (4 + R() * 52).toFixed(1) + '%;--ma:' + (26 + R() * 16).toFixed(0) + 'deg;--ml:' + Math.round(520 + R() * 420) + 'px;--md:' + (0.8 + R() * 0.6).toFixed(2) + 's';
    d.body.appendChild(m);
    setTimeout(function(){ if (m.parentNode) m.parentNode.removeChild(m); }, 1800);
  }
  function loop(){ setTimeout(function(){ streak(); loop(); }, 9000 + R() * 16000); }
  loop();
})();


/* ==========================================================================
   V108 · THE SPACEWALK — the head turn. Mouse on a desk, tilt on a phone
   where the browser hands it over without a permission sheet (iOS asks, so
   iOS gets the mouse-free version), and a touch of scroll. Writes two
   numbers onto <html>, --lx and --ly in -1..1; the sheet does the rest.
   Also hangs Earth and the craft in the frame. Off for reduced motion.
   ========================================================================== */
(function(){
  'use strict';
  var d = document, de = d.documentElement;
  if (!d.body) return;
  var REDUCED = false; try { REDUCED = matchMedia('(prefers-reduced-motion: reduce)').matches; } catch(e){}
  /* the mothership: the saucer the vessels arrive on, at your shoulder */
  var MOTHERSHIP = "<svg class=\"ms\" viewBox=\"0 0 600 300\" aria-hidden=\"true\">\n  <defs>\n    <linearGradient id=\"msHull\" x1=\"0\" y1=\"0\" x2=\"0\" y2=\"1\"><stop offset=\"0\" stop-color=\"#16243F\"/><stop offset=\".55\" stop-color=\"#0B1220\"/><stop offset=\"1\" stop-color=\"#05080F\"/></linearGradient>\n    <linearGradient id=\"msDome\" x1=\"0\" y1=\"0\" x2=\"0\" y2=\"1\"><stop offset=\"0\" stop-color=\"#1E3158\"/><stop offset=\"1\" stop-color=\"#0B1220\"/></linearGradient>\n    <linearGradient id=\"msBeam\" x1=\"0\" y1=\"0\" x2=\"0\" y2=\"1\"><stop offset=\"0\" stop-color=\"#00CE7E\" stop-opacity=\".34\"/><stop offset=\"1\" stop-color=\"#00CE7E\" stop-opacity=\"0\"/></linearGradient>\n    <radialGradient id=\"msGlow\" cx=\".5\" cy=\".5\" r=\".5\"><stop offset=\"0\" stop-color=\"#00CE7E\" stop-opacity=\".55\"/><stop offset=\"1\" stop-color=\"#00CE7E\" stop-opacity=\"0\"/></radialGradient>\n  </defs>\n  <!-- the beam: the vessels come down this -->\n  <path class=\"ms-beam\" d=\"M228 196 L372 196 L448 300 L152 300 Z\" fill=\"url(#msBeam)\"/>\n  <!-- saucer -->\n  <ellipse cx=\"300\" cy=\"158\" rx=\"292\" ry=\"54\" fill=\"url(#msHull)\" stroke=\"#2A3E66\" stroke-width=\"2\"/>\n  <ellipse cx=\"300\" cy=\"148\" rx=\"292\" ry=\"42\" fill=\"none\" stroke=\"#3A5080\" stroke-width=\"1.2\" opacity=\".55\"/>\n  <ellipse cx=\"300\" cy=\"140\" rx=\"206\" ry=\"34\" fill=\"#0E1A33\" stroke=\"#1B2A4A\" stroke-width=\"1.5\"/>\n  <!-- rim plating -->\n  <path d=\"M40 150 Q300 118 560 150\" fill=\"none\" stroke=\"#1B2A4A\" stroke-width=\"1\"/>\n  <path d=\"M12 160 Q300 132 588 160\" fill=\"none\" stroke=\"#1B2A4A\" stroke-width=\"1\"/>\n  <!-- the dome and the bridge: the crew's mark, lit -->\n  <ellipse cx=\"300\" cy=\"120\" rx=\"98\" ry=\"46\" fill=\"url(#msDome)\" stroke=\"#2A3E66\" stroke-width=\"2\"/>\n  <ellipse cx=\"300\" cy=\"112\" rx=\"70\" ry=\"30\" fill=\"url(#msGlow)\"/>\n  <g class=\"ms-mark\" transform=\"translate(270 82) scale(.6)\">\n    <path d=\"M50 6 C77 6 92 26 92 48 C92 74 72 96 50 104 C28 96 8 74 8 48 C8 26 23 6 50 6 Z\" fill=\"#0D2416\" stroke=\"#00CE7E\" stroke-width=\"4\"/>\n    <g class=\"ms-eye\"><ellipse cx=\"33\" cy=\"52\" rx=\"14\" ry=\"20\" transform=\"rotate(-18 33 52)\" fill=\"#00CE7E\"/><circle cx=\"33\" cy=\"52\" r=\"5\" fill=\"#04120A\"/></g>\n    <g class=\"ms-eye\"><ellipse cx=\"67\" cy=\"52\" rx=\"14\" ry=\"20\" transform=\"rotate(18 67 52)\" fill=\"#00CE7E\"/><circle cx=\"67\" cy=\"52\" r=\"5\" fill=\"#04120A\"/></g>\n  </g>\n  <!-- running lights along the rim, in the five crew inks -->\n  <g class=\"ms-lights\">\n    <circle class=\"ms-light\" style=\"--i:0\" cx=\"52\"  cy=\"176\" r=\"4.5\" fill=\"#00CE7E\"/>\n    <circle class=\"ms-light\" style=\"--i:1\" cx=\"114\" cy=\"190\" r=\"4.5\" fill=\"#EA41AA\"/>\n    <circle class=\"ms-light\" style=\"--i:2\" cx=\"180\" cy=\"200\" r=\"4.5\" fill=\"#FC4539\"/>\n    <circle class=\"ms-light\" style=\"--i:3\" cx=\"250\" cy=\"207\" r=\"4.5\" fill=\"#F8E44B\"/>\n    <circle class=\"ms-light\" style=\"--i:4\" cx=\"320\" cy=\"209\" r=\"4.5\" fill=\"#389EE1\"/>\n    <circle class=\"ms-light\" style=\"--i:5\" cx=\"390\" cy=\"206\" r=\"4.5\" fill=\"#00CE7E\"/>\n    <circle class=\"ms-light\" style=\"--i:6\" cx=\"456\" cy=\"198\" r=\"4.5\" fill=\"#EA41AA\"/>\n    <circle class=\"ms-light\" style=\"--i:7\" cx=\"516\" cy=\"187\" r=\"4.5\" fill=\"#FC4539\"/>\n    <circle class=\"ms-light\" style=\"--i:8\" cx=\"566\" cy=\"173\" r=\"4.5\" fill=\"#F8E44B\"/>\n  </g>\n  <!-- the hold hatch, open -->\n  <ellipse cx=\"300\" cy=\"200\" rx=\"60\" ry=\"9\" fill=\"#0A2B1C\" stroke=\"#00CE7E\" stroke-width=\"1.5\" opacity=\".9\"/>\n  <ellipse cx=\"300\" cy=\"200\" rx=\"46\" ry=\"6\" fill=\"#00CE7E\" opacity=\".35\"/>\n</svg>";
  /* Earth and the craft */
  /* V123: Earth was taken out of the frame at the captain's request — the sky, the ship and the stars stay */
  /* THE VISIT (V125): the ship is an event, not furniture. A theme setting sets the rate; the
     engine decides per visit whether it is docked on arrival, when it warps in, how long it
     stays, and when it comes back. 'always' is the old behaviour; 'never' keeps the sky clear. */
  var RATE = (typeof window.STATION_MOTHERSHIP === 'string') ? window.STATION_MOTHERSHIP : 'sometimes';
  var RATES = { never: null, rare: { at: 0.15, first: [120, 240], stay: [35, 50], gap: [240, 420] }, sometimes: { at: 0.4, first: [40, 100], stay: [45, 70], gap: [120, 240] }, often: { at: 0.75, first: [20, 50], stay: [60, 90], gap: [60, 120] }, always: { at: 1, first: [0, 0], stay: [1e9, 1e9], gap: [0, 0] } };
  var plan = (RATE in RATES) ? RATES[RATE] : RATES.sometimes;
  if (plan && !d.querySelector('.hull')) {
    var hl = d.createElement('div'); hl.className = 'hull'; hl.setAttribute('aria-hidden', 'true');
    hl.innerHTML = MOTHERSHIP + '<img class="ms-drop" alt="" draggable="false">';
    d.body.appendChild(hl);
    /* every so often a vessel comes down the beam: the mothership is where they come from */
    var drop = hl.querySelector('.ms-drop'), crews = ['green','pink','red','yellow','blue'], di = 0;
    function src(k){ try { if (typeof OG_IMG !== 'undefined' && OG_IMG && OG_IMG[k]) return OG_IMG[k]; } catch(e){} var base = (typeof window.STATION_ASSETS === 'string') ? window.STATION_ASSETS : ''; return base ? base + 'og-' + k + '-618.webp' : ''; }
    function deliver(){
      if (!d.hidden && !de.classList.contains('day')) {
        var k = crews[di++ % crews.length], u = src(k);
        if (u) { drop.src = u; drop.classList.remove('go'); void drop.offsetWidth; drop.classList.add('go'); }
      }
      setTimeout(deliver, 11000 + Math.random() * 12000);
    }
    if (!matchMedia('(prefers-reduced-motion: reduce)').matches) setTimeout(deliver, 3000);
    /* the visit clock */
    var vr = (function(){ var s = ((Date.now() >>> 3) ^ 0x9E37) & 0xffff || 11; return function(){ s ^= s << 13; s >>>= 0; s ^= s >>> 17; s ^= s << 5; s >>>= 0; return (s % 100000) / 100000; }; })();
    function span(r){ return (r[0] + vr() * (r[1] - r[0])) * 1000; }
    function dock(){ hl.classList.add('docked'); hl.classList.add('warp'); setTimeout(function(){ hl.classList.remove('warp'); }, 1100); if (plan.stay[0] < 1e8) setTimeout(undock, span(plan.stay)); }
    function undock(){ hl.classList.add('warp'); setTimeout(function(){ hl.classList.remove('docked'); hl.classList.remove('warp'); }, 500); setTimeout(dock, span(plan.gap)); }
    if (vr() < plan.at) dock(); else setTimeout(dock, span(plan.first));
    window.STATION_SHIP_NOW = dock;
  }
  /* V112: the mothership rides with the front deck and goes when it goes */
  var hullEl = d.querySelector('.hull'), heroEl = d.getElementById('arrivals');
  if (hullEl && heroEl) {
    try { if ('IntersectionObserver' in window) new IntersectionObserver(function(es){ es.forEach(function(en){ hullEl.classList.toggle('away', !en.isIntersecting); }); }, { threshold: 0 }).observe(heroEl); } catch(e){}
  }
  if (REDUCED) return;
  var lx = 0, ly = 0, tx = 0, ty = 0, raf = 0;
  function paint(){ raf = 0; lx += (tx - lx) * 0.18; ly += (ty - ly) * 0.18; de.style.setProperty('--lx', lx.toFixed(3)); de.style.setProperty('--ly', ly.toFixed(3)); if (Math.abs(tx - lx) > 0.002 || Math.abs(ty - ly) > 0.002) raf = requestAnimationFrame(paint); }
  function aim(x, y){ tx = Math.max(-1, Math.min(1, x)); ty = Math.max(-1, Math.min(1, y)); if (!raf) raf = requestAnimationFrame(paint); }
  var fine = false; try { fine = matchMedia('(pointer: fine)').matches; } catch(e){}
  if (fine) addEventListener('pointermove', function(e){ aim((e.clientX / innerWidth) * 2 - 1, (e.clientY / innerHeight) * 2 - 1); }, { passive: true });
  /* V112: and the ship follows the hand — slowly, the beam trying to land on the pointer */
  if (fine && hullEl) {
    var hx = null, hy = null, gx = null, gy = null, hraf = 0, hlast = 0;
    function hstep(now){
      hraf = 0;
      if (hx === null) { var r0 = hullEl.getBoundingClientRect(); hx = r0.left; hy = r0.top; }
      var dt = hlast ? Math.min(0.1, (now - hlast) / 1000) : 0.016; hlast = now;
      var k = 1 - Math.exp(-dt / 0.55);   /* time-based ease: the same float at any frame rate */
      hx += (gx - hx) * k; hy += (gy - hy) * k;
      hullEl.style.left = hx.toFixed(1) + 'px'; hullEl.style.top = hy.toFixed(1) + 'px';
      if (Math.abs(gx - hx) > 0.5 || Math.abs(gy - hy) > 0.5) hraf = requestAnimationFrame(hstep);
    }
    function aimShip(x, y){
      var W = hullEl.offsetWidth || 600, H = hullEl.offsetHeight || 300;
      /* V115: the ship belongs to the front deck — it never crosses the deck's bottom edge */
      var hb = heroEl ? heroEl.getBoundingClientRect() : { top: 0, bottom: innerHeight };
      var floor = Math.min(innerHeight, hb.bottom) - 10;
      gx = Math.max(-0.55 * W, Math.min(innerWidth - 0.45 * W, x - W * 0.5));
      gy = Math.max(Math.max(-0.25 * H, hb.top - 0.35 * H), Math.min(floor - H * 0.92, y - H * 0.92));   /* the beam's mouth sits just above the point, never below the deck */
      if (!hraf) hraf = requestAnimationFrame(hstep);
    }
    /* V113: when the hand rests, the ship goes where the sale is — the beam lands on CLAIM YOUR COLOR */
    var claimBtn = d.getElementById('quickClaimBtn'), idle = 0, beaming = false;
    function beamTheButton(){
      if (!claimBtn || hullEl.classList.contains('away') || !hullEl.classList.contains('docked')) return;
      var r = claimBtn.getBoundingClientRect();
      if (r.width < 10 || r.bottom < 0 || r.top > innerHeight) return;
      beaming = true; hullEl.classList.add('beaming'); claimBtn.classList.add('beamed');
      aimShip(r.left + r.width / 2, r.top - 6);
    }
    function unbeam(){ if (!beaming) return; beaming = false; hullEl.classList.remove('beaming'); if (claimBtn) claimBtn.classList.remove('beamed'); }
    addEventListener('pointermove', function(e){
      if (hullEl.classList.contains('away') || !hullEl.classList.contains('docked')) return;
      clearTimeout(idle); idle = setTimeout(beamTheButton, 1900);
      if (claimBtn) { var r = claimBtn.getBoundingClientRect(); if (e.clientX >= r.left - 40 && e.clientX <= r.right + 40 && e.clientY >= r.top - 40 && e.clientY <= r.bottom + 40) { beamTheButton(); return; } }
      unbeam();
      aimShip(e.clientX, e.clientY);
    }, { passive: true });
    idle = setTimeout(beamTheButton, 4200);   /* nobody has moved yet: show them where it is */
    addEventListener('scroll', function(){ if (beaming) beamTheButton(); }, { passive: true });
  }
  /* a phone in the hand: tilt, only where it arrives unasked */
  var tilted = false;
  if ('DeviceOrientationEvent' in window && typeof DeviceOrientationEvent.requestPermission !== 'function') {
    addEventListener('deviceorientation', function(e){
      if (e.gamma === null || e.beta === null) return;
      tilted = true;
      aim(Math.max(-1, Math.min(1, e.gamma / 28)), Math.max(-1, Math.min(1, (e.beta - 40) / 28)));
    }, { passive: true });
  }
  /* scrolling is also looking: a little */
  var sy0 = scrollY;
  addEventListener('scroll', function(){ if (fine || tilted) return; var v = (scrollY - sy0) / Math.max(1, innerHeight); aim(Math.sin(v * 1.3) * 0.25, Math.max(-1, Math.min(1, v * 0.35))); }, { passive: true });
})();


/* ==========================================================================
   V114 · THE FORECOURT — the register opens the hold; the one in the queue
   is a different crew member every visit and stays identified for the
   session once you've called it.
   ========================================================================== */
function wireForecourt(){
  'use strict';
  var d = document;
  /* V121 · fcStage pan: on a phone the forecourt is wider than the screen; open it on the pumps */
  var st = d.getElementById('fcStage');
  /* V137: the field house is a second stage — same slide, same centring, same rest */
  var fh = d.getElementById('fhStage');
  if (fh) {
    var fhc = function(){ if (fh.scrollWidth > fh.clientWidth + 10) fh.scrollLeft = (fh.scrollWidth - fh.clientWidth) * 0.5; };
    fhc(); setTimeout(fhc, 400);
    var fhArmed = false; setTimeout(function(){ fhArmed = true; }, 900);
    fh.addEventListener('scroll', function(){ if (fhArmed) fh.classList.add('panned'); }, { passive: true });
    try { if ('IntersectionObserver' in window) new IntersectionObserver(function(es){ es.forEach(function(en){ fh.classList.toggle('fc-off', !en.isIntersecting); }); }, { threshold: 0 }).observe(fh); } catch(e){}
  }
  /* V141 · per-floor rest: each level of the building pauses when it is out of view (V144: wired after the stamp) */
  function restFloors(){ if (!(st && 'IntersectionObserver' in window)) return;
    try {
      var floors = st.querySelectorAll('svg.fc-inner');
      if (floors.length) new IntersectionObserver(function(es){ es.forEach(function(en){ en.target.classList.toggle('fl-off', !en.isIntersecting); }); }, { threshold: 0.3 }).observe && (function(io){ floors.forEach(function(f){ io.observe(f); }); })(new IntersectionObserver(function(es){ es.forEach(function(en){ en.target.classList.toggle('fl-off', !en.isIntersecting); }); }, { threshold: 0.3 }));
    } catch(e){}
  }
  if (d.querySelector('#fcStage svg.fc-inner')) restFloors(); else d.addEventListener('station:building', restFloors, { once: true });
  if (st) {
    function centre(){ if (st.scrollWidth > st.clientWidth + 10) st.scrollLeft = (st.scrollWidth - st.clientWidth) * 0.5; }
    centre(); setTimeout(centre, 400);
    var armed = false; setTimeout(function(){ armed = true; }, 900);   /* the opening centre is not the visitor's slide */
    st.addEventListener('scroll', function(){ if (armed) st.classList.add('panned'); }, { passive: true });
  }
  /* V122 · fc-ship rotation: a different ship pulls into the spot every loop, swapped while it is off the screen */
  var shipEl = st ? st.querySelector('.fc-ship') : null;
  if (st && shipEl) {
    var SHIPS = ['rocket', 'saucer', 'bus', 'capsule', 'camper'], si = 0;
    try { si = (parseInt(localStorage.getItem('stationHero.visits') || '0', 10) || 0) % SHIPS.length; } catch(e){}
    st.setAttribute('data-ship', SHIPS[si]);
    shipEl.addEventListener('animationiteration', function(e){ if (e.target !== shipEl) return; si = (si + 1) % SHIPS.length; st.setAttribute('data-ship', SHIPS[si]); });
  }
  var reg = d.getElementById('fcRegister');
  if (reg) {
    function pay(){ if (typeof openHold === 'function') openHold(); else if (window.STATION_LOCK) window.location.href = '/cart'; else location.hash = '#/bottles'; }
    reg.addEventListener('click', pay);
    reg.addEventListener('keydown', function(e){ if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pay(); } });
  }
  /* V156 · the traffic guard: a cone with eyes at the foot of the ramp */
  var gd = d.getElementById('fgGuard');
  if (gd) {
    var gdone = false; try { gdone = sessionStorage.getItem('stationCone') === '1'; } catch(e){}
    if (gdone) gd.classList.add('id');
    function cone(){ if (gd.classList.contains('id')) return; gd.classList.add('id'); try { sessionStorage.setItem('stationCone', '1'); } catch(e){} if (typeof showToast === 'function') showToast('SIGHTING CONFIRMED \u00b7 THE CONE HAD EYES THE WHOLE TIME'); }
    gd.addEventListener('click', cone);
    gd.addEventListener('keydown', function(e){ if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); cone(); } });
  }
  var uc = d.getElementById('fcUndercover');
  if (uc) {
    var CREW = [['green','#00CE7E','#0D2416','OKO'],['pink','#EA41AA','#26081F','VESP'],['red','#FC4539','#2A0705','KOR'],['yellow','#F8E44B','#2A2405','SOL'],['blue','#389EE1','#04122A','RIME']];
    var v = 0; try { v = parseInt(localStorage.getItem('stationHero.visits') || '0', 10) || 0; } catch(e){}
    var c = CREW[v % CREW.length];
    uc.style.setProperty('--uc', c[1]); uc.style.setProperty('--uc-ink', c[2]);
    var tag = uc.querySelector('.fc-uc-tag'); if (tag) tag.textContent = 'IDENTIFIED \u00b7 ' + c[3] + ' \u00b7 UNDERCOVER';
    /* the cashier is the next one in the crew — never the one in the queue */
    var cashier = d.getElementById('fcCashier');
    if (cashier) { var c2 = CREW[(v + 1) % CREW.length]; d.querySelectorAll('.fc-cashier').forEach(function(el){ el.style.setProperty('--uc2', c2[1]); el.style.setProperty('--uc2-ink', c2[2]); }); var ct = cashier.querySelector('.fc-cashier-tag'); if (ct) ct.textContent = c2[3]; }
    var done = false; try { done = sessionStorage.getItem('stationUC') === c[0]; } catch(e){}
    if (done) uc.classList.add('id');
    function identify(){
      if (uc.classList.contains('id')) return;
      uc.classList.add('id');
      try { sessionStorage.setItem('stationUC', c[0]); } catch(e){}
      if (typeof showToast === 'function') showToast('SIGHTING CONFIRMED \u00b7 ' + c[3] + ' WAS IN THE QUEUE THE WHOLE TIME');
    }
    uc.addEventListener('click', function(e){ if (e.target.closest('.fc-uc-log')) return; identify(); });
    uc.addEventListener('keydown', function(e){ if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); identify(); } });
  }
}
if (document.getElementById('fcRegister')) wireForecourt(); else document.addEventListener('station:building', wireForecourt, { once: true });



/* ==========================================================================
   V133 · THE DOCKING BAY — arrivals by QR. ?dock=<code> on any deck with the
   layout: a docking pass card once, DOCKED AT <CODE> in the ticker for the
   session, the code kept in sessionStorage so it survives the decks. Also:
   the forecourt rests when it is off the screen, and ?lab=1 opens the
   header type lab in the footer (a workshop tool, not for customers).
   ========================================================================== */
(function(){
  'use strict';
  var d = document, de = d.documentElement;
  if (/[?&]lab=1/.test(location.search)) de.classList.add('lab');
  /* the forecourt rests off-screen */
  var st = d.getElementById('fcStage');
  if (st && 'IntersectionObserver' in window) {
    try { new IntersectionObserver(function(es){ es.forEach(function(en){ st.classList.toggle('fc-off', !en.isIntersecting); }); }, { threshold: 0 }).observe(st); } catch(e){}
    d.addEventListener('visibilitychange', function(){ if (d.hidden) st.classList.add('fc-off'); else { var r = st.getBoundingClientRect(); st.classList.toggle('fc-off', r.bottom < 0 || r.top > innerHeight); } });
  }
  /* the docking bay */
  var m = /[?&]dock=([A-Za-z0-9_-]{2,40})/.exec(location.search), code = null, fresh = false;
  if (m) { code = m[1].toLowerCase(); fresh = true; try { sessionStorage.setItem('stationDock', code); } catch(e){} }
  else { try { code = sessionStorage.getItem('stationDock'); } catch(e){} }
  if (!code) return;
  var CODE = code.replace(/[-_]+/g, ' ').toUpperCase();
  function esc(s){ return String(s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  /* the ticker carries it for the visit */
  d.querySelectorAll('.tk-set').forEach(function(set){
    if (set.querySelector('.tk-dock')) return;
    var sp = d.createElement('span'); sp.className = 'tk-i tk-dock'; sp.textContent = 'DOCKED AT ' + CODE + ' \u00b7 EXPO PASS ACTIVE';
    var dot = d.createElement('i'); dot.className = 'tk-d'; dot.textContent = '\u25c9';
    set.insertBefore(dot, set.firstChild); set.insertBefore(sp, set.firstChild);
  });
  /* the pass, once per arrival */
  var seen = false; try { seen = sessionStorage.getItem('stationDock.pass') === code; } catch(e){}
  if (!fresh || seen || !d.getElementById('arrivals')) return;
  var head = (window.STATION_DOCK_HEAD || 'You docked at [code].').replace('[code]', CODE).replace('{code}', CODE);
  var line = window.STATION_DOCK_LINE || 'You found the station.';
  var crew = ['#00CE7E', '#EA41AA', '#FC4539', '#F8E44B', '#389EE1'];
  var pass = d.createElement('div'); pass.className = 'dock-pass'; pass.setAttribute('role', 'dialog'); pass.setAttribute('aria-label', 'Docking pass');
  pass.innerHTML = '<div class="dock-card"><button class="dock-x" type="button" aria-label="Close">\u00d7</button>'
    + '<div class="dock-k">DOCKING BAY \u00b7 PASS ACCEPTED \u00b7 ' + esc(CODE) + '</div>'
    + '<h2>' + esc(head).replace(esc(CODE), '<em>' + esc(CODE) + '</em>') + '</h2>'
    + '<p class="dock-line">' + esc(line) + '</p>'
    + '<div class="dock-crew" aria-hidden="true">' + crew.map(function(h){ return '<i style="--h:' + h + '"></i>'; }).join('') + '</div>'
    + '<div class="dock-acts"><button class="btn btn-gold" type="button" data-dock="claim">CLAIM YOUR COLOR \u00b7 $33</button><button class="btn-line" type="button" data-dock="crew">MEET THE CREW</button></div>'
    + '<div class="dock-ad">HOUSE AD \u00b7 <a href="https://siderep.co" rel="noopener">SIDEREP \u2014 THE APP THE CREW USE BETWEEN VESSELS</a></div>'
    + '<div class="dock-note">THIS PASS STAYS ON YOUR PHONE FOR THE VISIT \u00b7 THE STATION \u00b7 COLORADO</div></div>';
  d.body.appendChild(pass);
  function close(){ if (pass.parentNode) pass.parentNode.removeChild(pass); try { sessionStorage.setItem('stationDock.pass', code); } catch(e){} }
  pass.addEventListener('click', function(e){
    if (e.target === pass || e.target.closest('.dock-x')) { close(); return; }
    var b = e.target.closest('[data-dock]'); if (!b) return;
    var what = b.getAttribute('data-dock'); close();
    if (what === 'claim') { var q = d.getElementById('quickClaimBtn'); if (q) { q.scrollIntoView({ block: 'center' }); setTimeout(function(){ q.click(); }, 350); } else location.hash = '#/bottles'; }
    if (what === 'crew') { var c = d.getElementById('crew'); if (c) c.scrollIntoView({ block: 'start' }); }
  });
  d.addEventListener('keydown', function(e){ if (e.key === 'Escape') close(); });
})();


/* ==========================================================================
   V144 · THE STAGED LOAD — the sky lifts its veil after the first frame;
   the building is stamped from its template when the visitor is within a
   screen of it (or on idle, if they never scroll), then the forecourt is
   wired and the floors watched. Three layers, one over the other.
   ========================================================================== */
(function(){
  'use strict';
  var d = document, de = d.documentElement;
  function skyOn(){ de.classList.add('sky-on'); }
  if ('requestAnimationFrame' in window) requestAnimationFrame(function(){ requestAnimationFrame(skyOn); }); else skyOn();
  setTimeout(skyOn, 900);
  setTimeout(function(){ var v = d.getElementById('voidVeil'); if (v && v.parentNode) v.parentNode.removeChild(v); }, 3200);
  var st = d.getElementById('fcStage'), tpl = d.getElementById('fcBuilding');
  if (!st || !tpl) return;
  var done = false;
  function stamp(){
    if (done) return; done = true;
    try {
      var node = tpl.content ? tpl.content.cloneNode(true) : null;
      if (!node) { var tmp = d.createElement('div'); tmp.innerHTML = tpl.innerHTML; node = d.createDocumentFragment(); while (tmp.firstChild) node.appendChild(tmp.firstChild); }
      st.insertBefore(node, tpl.nextSibling);
      st.classList.add('stamped');
      if (st.scrollWidth > st.clientWidth + 10) st.scrollLeft = (st.scrollWidth - st.clientWidth) * 0.5;
      d.dispatchEvent(new CustomEvent('station:building'));
    } catch(e){ done = false; }
  }
  var touch = false; try { touch = window.matchMedia('(hover: none) and (pointer: coarse)').matches; } catch(e){}
  var lifeboat = de.classList.contains('lifeboat');
  if (lifeboat) { var sk = st.querySelector('.fc-skeleton'); if (sk) sk.addEventListener('click', stamp); return; }   /* V183 · in the lifeboat the building loads only when asked */
  function unstamp(){   /* V179 · on a phone the building leaves the page when you are far from it, and comes back when you are near: memory, not speed */
    if (!done) return;
    var layers = st.querySelector('.bl-layers'); if (layers && layers.parentNode) layers.parentNode.removeChild(layers);
    st.classList.remove('stamped'); done = false;
  }
  if ('IntersectionObserver' in window) {
    try {
      if (touch) new IntersectionObserver(function(es){ es.forEach(function(en){ if (en.isIntersecting) stamp(); else if (done && Math.abs(en.boundingClientRect.top) > innerHeight * 4) unstamp(); }); }, { rootMargin: '500px 0px' }).observe(st);
      else new IntersectionObserver(function(es, io){ es.forEach(function(en){ if (en.isIntersecting) { stamp(); io.disconnect(); } }); }, { rootMargin: '900px 0px' }).observe(st);
    } catch(e){ stamp(); }
  } else stamp();
  if (!touch) { var idle = window.requestIdleCallback || function(f){ return setTimeout(f, 2500); }; idle(function(){ if (!done) setTimeout(stamp, 1500); }, { timeout: 6000 }); }
  window.STATION_STAMP = stamp;
})();


/* ==========================================================================
   V168 · THE HOLD LAYOUT — Shopify draws the express buttons as a tall
   vertical stack; ask it for the horizontal layout so they sit two to a row.
   ========================================================================== */
(function(){
  var d = document, ex = d.querySelector('.hold-express .additional-checkout-buttons');
  if (ex && ex.classList.contains('additional-checkout-buttons--vertical')) { ex.classList.remove('additional-checkout-buttons--vertical'); ex.classList.add('additional-checkout-buttons--horizontal'); }
})();


/* V179 · THE TICKER HEIGHT — the menu sits under whatever height the ticker actually has on this screen */
(function(){
  var d = document, tk = d.querySelector('.ticker'); if (!tk) return;
  var sliding = false;
  function set(){
    if (sliding || d.documentElement.classList.contains('tkhide')) return;   /* V191: only a settled, open ticker sets the menu's offset */
    try { if (tk.getAnimations && tk.getAnimations().length) return; } catch(e){}   /* V193: a ticker mid-slide never sets it, whatever the events said */
    var h = Math.ceil(tk.getBoundingClientRect().height - 0.001);   /* V193: never round the menu up under the ticker's bottom edge */
    if (h > 0) d.documentElement.style.setProperty('--tk-h', h + 'px');
  }
  set(); addEventListener('resize', set);
  ['transitionrun', 'transitionstart'].forEach(function(ev){ tk.addEventListener(ev, function(e){ if (!e.propertyName || e.propertyName === 'height') sliding = true; }); });
  ['transitionend', 'transitioncancel'].forEach(function(ev){ tk.addEventListener(ev, function(e){ if (!e.propertyName || e.propertyName === 'height') { sliding = false; set(); } }); });
  if ('ResizeObserver' in window) { try { new ResizeObserver(set).observe(tk); } catch(e){} }
})();


/* V185 · NO PROVIDER SDKS ON PHONES — a desk stamps the one-tap block into the hold before the page finishes loading (Shopify's script finds it there); a phone gets a line instead and never loads the three SDKs */
(function(){
  var d = document, ex = d.getElementById('holdExpress'), tpl = d.getElementById('expressTpl'), more = d.getElementById('holdMore'), line = d.getElementById('holdExpressPhone');
  if (!ex) return;
  var touch = false; try { touch = window.matchMedia('(hover: none) and (pointer: coarse)').matches; } catch(e){}
  var lifeboat = d.documentElement.classList.contains('lifeboat');
  if (touch || lifeboat) {
    if (more) more.hidden = true; if (line) line.hidden = false; ex.hidden = true;
    return;
  }
  if (tpl) { try { ex.appendChild(tpl.content ? tpl.content.cloneNode(true) : d.createRange().createContextualFragment(tpl.innerHTML)); } catch(e){} }
  if (more) more.hidden = true;
  ex.classList.add('open');
})();


/* V182 · ONE DOOR AT A TIME — the page knows when the hold is open */
(function(){
  var d = document, hold = d.getElementById('hold'); if (!hold || !('MutationObserver' in window)) return;
  function sync(){ d.documentElement.classList.toggle('hold-open', hold.classList.contains('open')); }
  new MutationObserver(sync).observe(hold, { attributes: true, attributeFilter: ['class'] }); sync();
})();


/* V185 · the lifeboat's way back: tap the low-power line to try the full station again */
(function(){
  if (!document.documentElement.classList.contains('lifeboat')) return;
  document.addEventListener('click', function(e){ if (e.clientY > innerHeight - 44 && e.target === document.body) { location.href = location.pathname + '?fullstation=1'; } });
  var b = document.createElement('button'); b.type = 'button'; b.textContent = 'LOW POWER \u00b7 TAP FOR THE FULL STATION'; b.setAttribute('style', 'position:fixed;left:0;right:0;bottom:0;z-index:501;padding:12px;border:0;background:#F0C75E;color:#05070C;font-family:var(--mono);font-size:10px;letter-spacing:.2em;cursor:pointer');
  b.addEventListener('click', function(){ location.href = location.pathname + '?fullstation=1'; });
  document.body.appendChild(b);
})();

/* V188 · BOOTH MODE — ?booth=1 (or a saved booth) pins the tablet to the front deck and resets after ninety idle seconds */
(function(){
  var d = document, de = d.documentElement, on = /[?&]booth=1/.test(location.search); try { if (on) sessionStorage.setItem('stationBooth', '1'); else if (sessionStorage.getItem('stationBooth') === '1') on = true; } catch(e){}
  if (!on) return;
  de.classList.add('booth');
  try { if (window.STATION_HERO_SET) window.STATION_HERO_SET('vessel'); } catch(e){}
  var last = Date.now();
  ['touchstart','pointerdown','keydown','scroll'].forEach(function(ev){ addEventListener(ev, function(){ last = Date.now(); }, { passive: true }); });
  setInterval(function(){ if (Date.now() - last > 90000) { last = Date.now(); location.href = location.pathname + '?booth=1'; } }, 5000);
})();


/* V190 · THE TALLY — first-party counts, no cookies, no ids, no third party: a deck viewed, a dial turned, a coin tossed, a claim, a docking. Beacons go to the shop's own /apps/station/tally; if the worker is not there yet, nothing happens and nothing is stored. */
(function(){
  var d = document, BASE = window.STATION_PURSER_BASE || '/apps/station';
  function send(e, v){ if (!window.STATION_SHOP) return; try { var body = JSON.stringify({ e: e, v: String(v || '').slice(0, 24), h: new Date().getHours(), p: location.pathname.slice(0, 40) }); if (navigator.sendBeacon) navigator.sendBeacon(BASE + '/tally', new Blob([body], { type: 'application/json' })); else fetch(BASE + '/tally', { method: 'POST', body: body, keepalive: true, headers: { 'content-type': 'application/json' } }).catch(function(){}); } catch(err){} }
  window.STATION_TALLY = send;
  send('view', d.documentElement.getAttribute('data-hero') || 'page');
  d.addEventListener('click', function(ev){
    var t = ev.target;
    if (t.closest('.hd-b')) send('dial', (t.closest('.hd-b').dataset.mode || t.closest('.hd-b').dataset.deck || ''));
    else if (t.closest('[data-add]')) send('claim', t.closest('[data-add]').getAttribute('data-add'));
    else if (t.closest('.claim-btn, .menu-cta, .sb-buy, #buyPillGo')) send('claim', 'menu');
    else if (t.closest('#heroSky .bl-bottle')) send('toss', 'bottle');
    else if (t.closest('#heroSky .bl-head')) send('pop', 'head');
    else if (t.closest('[data-stand]')) send('stand', t.closest('[data-stand]').dataset.stand);
  }, true);
  if (/[?&]dock=/.test(location.search)) send('dock', (/[?&]dock=([A-Za-z0-9_-]{2,40})/.exec(location.search) || [])[1]);
})();


/* ============ V193 · LOW ORBIT II · decks at rest ============
   On a phone the home deck is forty screens tall. A deck more than a screen
   and a half from the viewport stops painting and its animations pause; it
   comes back the moment it is near. Layout never changes, so nothing jumps. */
(function(){
  var phone = false; try { phone = window.matchMedia('(max-width: 640px)').matches; } catch(e){}
  if (!phone || !('IntersectionObserver' in window)) return;
  var main = document.getElementById('top'); if (!main) return;
  var secs = [].slice.call(main.children).filter(function(el){ return el.tagName === 'SECTION' && el.id; });
  if (!secs.length) return;
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){ en.target.classList.toggle('orbit-off', !en.isIntersecting); });
  }, { root: null, rootMargin: '150% 0px 150% 0px', threshold: 0 });
  secs.forEach(function(s){ io.observe(s); });
  function wake(){ secs.forEach(function(s){ s.classList.remove('orbit-off'); }); }
  window.addEventListener('hashchange', wake, { passive: true });
  window.addEventListener('popstate', wake, { passive: true });
})();
